import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "end-booking",
  "use": "end-booking-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"end-booking\"><path fill-rule=\"evenodd\" d=\"M8 2.9a6 6 0 1 0 0 11.999 6 6 0 0 0 0-12m-5.657.342a8 8 0 1 1 11.314 11.314A8 8 0 0 1 2.343 3.242m9.064 2.25a1 1 0 0 1 0 1.415L9.415 8.9l1.992 1.992a1 1 0 1 1-1.414 1.414l-1.992-1.992-1.993 1.992a1 1 0 1 1-1.414-1.414L6.586 8.9 4.594 6.907a1 1 0 0 1 1.414-1.414L8 7.485l1.992-1.992a1 1 0 0 1 1.414 0\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol